import { createFileRoute } from "@tanstack/react-router";

import { PraxaSkillDetail } from "../components/praxa/PraxaSkillCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/skills/$skillId")({
  component: PraxaSkillDetailRoute,
});

function PraxaSkillDetailRoute() {
  const { workspaceId, skillId } = Route.useParams();
  return <PraxaSkillDetail skillId={skillId} workspaceId={workspaceId} />;
}
